import { WellbeingScoresEntity } from "api/src/wellbeing/entities/wellbeing-scores.entity";
import { useQuery } from "react-query";

import { api } from "../util/api";

export function useWellbeingScore() {
  return useQuery<WellbeingScoresEntity | undefined>(
    ["wellbeing/scores"],
    async () => {
      const response = await api.get<WellbeingScoresEntity>(
        "wellbeing/score",
        {}
      );

      if (response.status === 200) {
        return response.data;
      }

      return undefined;
    },
    {
      keepPreviousData: true,
    }
  );
}
